import { useTranslation } from 'react-i18next'

import { InputField } from '../../../Input'
import { Skeleton } from '../../../Skeleton'

import {
  QA_NAME_REQUEST_PROFILE_TAB_EMAILS_SEARCH,
  REQUEST_PROFILE_TAB_EMAILS_SEARCH_HEIGHT,
  REQUEST_PROFILE_TAB_EMAILS_SEARCH_MAX_LENGTH,
} from './RequestProfileTabEmailsSearch.constants'

import * as styles from './RequestProfileTabEmailsSearch.module.css'

import SearchIcon from '../../../../icons/search.svg'

function RequestProfileTabEmailsSearch({
  isSkeleton = false,
  value,
  onChange,
  onClear,
}) {
  const { t } = useTranslation()

  return isSkeleton ? (
    <Skeleton className={styles.skeleton} />
  ) : (
    <InputField
      afterIconProps={{
        Icon: SearchIcon,
      }}
      height={REQUEST_PROFILE_TAB_EMAILS_SEARCH_HEIGHT}
      maxLength={REQUEST_PROFILE_TAB_EMAILS_SEARCH_MAX_LENGTH}
      placeholder={t('Common.SearchPlaceholderKey')}
      qaName={QA_NAME_REQUEST_PROFILE_TAB_EMAILS_SEARCH}
      showError={false}
      value={value}
      wrapperClassName={styles.search}
      onChange={onChange}
      onClear={onClear}
    />
  )
}

export default RequestProfileTabEmailsSearch
